import classNames from "classnames";
import {observer} from "mobx-react";
import styles from './minute-media-player.module.scss';
import {MINUTE_MEDIA_PLAYER_CONFIG} from './minute-media-player.consts';
import {MinuteMediaPlayer} from './minute-media-player';
import {UseDevice} from "../../composers/composer-plugins/use-device";

export const MinuteMediaAdContainer = observer(UseDevice()(({
                                                              className,
                                                              device,
                                                              isMock = false,
                                                              shouldRenderTitle = true,
                                                            }) => {
  const {width, height} = device.isSmallView
    ? MINUTE_MEDIA_PLAYER_CONFIG.sizes.mobile
    : MINUTE_MEDIA_PLAYER_CONFIG.sizes.desktop;

  const containerClassName = classNames({
    [styles.mock]: isMock,
    [styles.with_title]: shouldRenderTitle,
  }, styles.container, className);

  const adStyle = {minWidth: width, minHeight: height};

  return (
    <div className={containerClassName}>
      <div className={classNames(styles.text)}>Ad</div>
      {
        isMock
          ? <div className={classNames(styles.ad)} style={adStyle}/>
          : <MinuteMediaPlayer className={classNames(styles.ad)} style={adStyle}/>
      }
    </div>
  );
}));
